import { render, staticRenderFns } from "./OrderDraftItems.vue?vue&type=template&id=cf58fbec&"
import script from "./OrderDraftItems.vue?vue&type=script&lang=js&"
export * from "./OrderDraftItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports